import { motion } from "framer-motion";
import { Quote, Star } from "lucide-react";
import { useLang } from "../lib/LanguageContext";

export const Testimonials = () => {
  const { t } = useLang();

  return (
    <section
      data-testid="testimonials-section"
      className="relative py-24 md:py-32 bg-brand-coffee text-brand-cream overflow-hidden"
    >
      {/* Decorative */}
      <div className="absolute top-0 right-0 w-[480px] h-[480px] rounded-full bg-brand-blue/15 blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-[360px] h-[360px] rounded-full bg-brand-gold/15 blur-[100px] pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="max-w-3xl">
          <span className="text-xs uppercase tracking-[0.32em] text-brand-gold font-medium">
            {t.testimonials.eyebrow}
          </span>
          <h2 className="mt-5 font-serif text-4xl sm:text-5xl lg:text-[3.4rem] leading-[1.05] tracking-tight text-brand-cream">
            {t.testimonials.title}
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-5 md:gap-6">
          {t.testimonials.items.map((item, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              data-testid={`testimonial-${i}`}
              className={`relative p-8 md:p-10 rounded-3xl border ${
                i % 2 === 0
                  ? "bg-brand-cream/5 border-brand-cream/15 backdrop-blur-md"
                  : "bg-brand-blue text-white border-brand-blue"
              }`}
            >
              <Quote
                className={`w-8 h-8 ${
                  i % 2 === 0 ? "text-brand-gold" : "text-white/40"
                }`}
                strokeWidth={1.4}
              />
              <blockquote
                className={`mt-5 font-serif italic text-xl md:text-2xl leading-snug tracking-tight ${
                  i % 2 === 0 ? "text-brand-cream" : "text-white"
                }`}
              >
                "{item.quote}"
              </blockquote>
              <figcaption className="mt-8 flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm font-medium ${
                      i % 2 === 0 ? "text-brand-cream" : "text-white"
                    }`}
                  >
                    {item.name}
                  </p>
                  <p
                    className={`text-xs uppercase tracking-widest mt-1 ${
                      i % 2 === 0 ? "text-brand-cream/60" : "text-white/70"
                    }`}
                  >
                    {item.role}
                  </p>
                </div>
                <div className="flex gap-0.5">
                  {Array(5)
                    .fill(0)
                    .map((_, s) => (
                      <Star
                        key={s}
                        className={`w-3.5 h-3.5 ${
                          i % 2 === 0
                            ? "fill-brand-gold text-brand-gold"
                            : "fill-white text-white"
                        }`}
                        strokeWidth={1.5}
                      />
                    ))}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};
